import React from "react";

const Project = () =>{
    return(
        <>
        <div className="project">
        <div className="projectH">
        PROJECT VISION 
        </div>
        <div className="bgColor "></div>
        <div className="bgColor2 "></div>
        <div className="imgDiv">
            <img alt='img1' className="img1" src="/Image/DALL·E 2024-07-14 20.01.25 - A wide 3D cartoon illustration of a group of furry Central Asian Shepherd dog friends. The dogs should have joyful expressions with wide smiles, ears_ 2.png" />
        </div>
        <div className="shadowImgDiv">
        <img alt='img1' className="img2" src="/Image/DALL·E 2024-07-14 20.01.25 - A wide 3D cartoon illustration of a group of furry Central Asian Shepherd dog friends. The dogs should have joyful expressions with wide smiles, ears_ 2.png" />
        </div>
        <div className="info">
        Our mission is to honor the heritage of the Alabay by creating a vibrant, loyal, and powerful community. Just as the Alabay protects its flock, we aim to build a pack that stands strong together.
        </div>
        </div>
        </>
    )
}

export default Project;